export default __webpack_public_path__ + "static/Asset3@2x-b25ef3b6f350d21cd9a12e45cd0abaa9.png";